<div class="embed-responsive embed-responsive-1by1">
    <iframe class="embed-responsive-item" src="https://datastudio.google.com/embed/reporting/e88ed916-60f9-48d0-91d1-d408bed7d7d4/page/UdaTB"></iframe>
  </div>